import { render, staticRenderFns } from "./DialogResetDemo.vue?vue&type=template&id=81e803d4&scoped=true"
import script from "./DialogResetDemo.vue?vue&type=script&lang=js"
export * from "./DialogResetDemo.vue?vue&type=script&lang=js"
import style0 from "./DialogResetDemo.vue?vue&type=style&index=0&id=81e803d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e803d4",
  null
  
)

export default component.exports